import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../App';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import './Navbar.css';

function Navbar() {
    const { isSignedIn, handleSignOut } = useContext(AuthContext);
    let navigate = useNavigate(); // Hook for programmatically navigating
    const [showDropdown, setShowDropdown] = useState(false);
    const goToPremium = () => {
        navigate('/premium'); // Navigate to premium page
    };

    const goToRegister = () => {
        navigate('/register'); // Navigate to register page
    };

    const goToSignIn = () => {
        navigate('/signin'); // Navigate to sign-in page
    };

    const goToAccount = () => {
        navigate('/account'); // Adjust the route as necessary
    };

    const goToInterviewQuestions = () => {
        navigate('/interview-questions'); // Navigate to interview questions page
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const signOutAndRedirect = () => {
        handleSignOut(); // Sign out the user
        navigate('/'); // Then redirect to the homepage
    };

    const fetchCustomerPortalUrl = async () => {
        try {
            const response = await axios.post('/create-customer-portal-session', {}, {
                withCredentials: true
            });

            const data = response.data;
            if (data.url) {
                // Redirect the user to the Customer Portal
                window.location.href = data.url;
            } else if (data.message) {
                // Navigate to the NoOrder component
                navigate('/no-order');
            }
        } catch (error) {
            console.error('Error fetching customer portal URL:', error);
            toast('Failed to redirect to the customer portal. Please try again.', {
                autoClose: 5000, // 5000 milliseconds = 5 seconds
            });
        }
    };

    // Modify your Navbar component to include the redirection logic
    const goToMyOrders = async () => {
        await fetchCustomerPortalUrl();
    };

    return (
        <header className="navbar">
            <div className="navbar-container">
                {/* Logo */}
                <div className="navbar-logo-and-name">
                    <a href="/" className="logo-link">
                        <img src="./favicon.svg" alt="Interview Prep Logo" />
                        <span className="website-name">Boost Interview</span> {/* Website Name Added */}
                    </a>
                </div>

                {/* Navigation Links */}
                <nav className="navbar-links">
                    <ul>
                        <li><button onClick={goToInterviewQuestions}>Interview Questions</button></li>
                        {/* ... other navigation links ... */}
                    </ul>
                </nav>

                {/* User Action Buttons */}
                <div className="navbar-actions">
                    {!isSignedIn ? (
                        <>
                            <button className="btn btn-sign-in" onClick={goToSignIn}>Sign In</button>
                            <button className="btn btn-register" onClick={goToRegister}>Register</button>
                        </>
                    ) : (
                        <>
                            <button className="btn btn-account" onClick={toggleDropdown}>Account</button>
                            {showDropdown && (
                                <div className="account-dropdown">
                                    <ul>
                                        <li onClick={() => navigate('/my-lists')}>My Lists</li>
                                        <li onClick={() => navigate('/my-submissions')}>My Submissions</li>
                                        <li onClick={goToMyOrders}>My Orders</li>
                                    </ul>
                                </div>
                            )}
                            <button className="btn btn-sign-out" onClick={signOutAndRedirect}>Sign out</button>
                        </>
                    )}
                    <button className="btn btn-premium" onClick={goToPremium}>Premium</button>
                </div>
                <ToastContainer position="top-center" autoClose={50000} />
            </div>
        </header>
    );
}

export default Navbar;